import { render, staticRenderFns } from "./BonusModal.vue?vue&type=template&id=4b9732e0&"
import script from "./BonusModal.vue?vue&type=script&lang=js&"
export * from "./BonusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports